<template>

	<section>
    
    <v-toolbar flat dense color="blue-grey lighten-5" class="report_bar">
      <v-toolbar-title>Packing</v-toolbar-title>

       <v-spacer></v-spacer>
          <v-btn
              icon
              color="accent-2"
              class="blue--text"
              v-if="packsReport && packsReport.length == 0 && isToday"
              @click="logInfo()"
            >
              <v-icon>mdi-clipboard-edit-outline</v-icon>
            </v-btn>

          <v-btn
              icon
              class="blue--text"
              v-else-if="packsReport && (packsReport.length == 1 && activePackers.length > 0) && isToday"
              
              @click="editReport(packsReport[0])"
            >
              <v-icon>mdi-clipboard-edit</v-icon>
            </v-btn>
    </v-toolbar>
		<v-row>

            <v-col cols="12" md="8">


    <v-data-iterator v-if="packJobs"
      :items="dailypacks.packs"

      hide-default-footer
    >
      <template v-slot:default="{ items }">
        <v-row>
          <v-col
            v-for="item in items"
            :key="item.id"
            cols="12"
            sm="6"
            md="6"
            lg="6"
          >
            <v-card>
              <v-card-title flat dense color="blue-grey lighten-5" class="subheading font-weight-bold">
                {{ item.name }}

                <v-spacer></v-spacer>

                <v-btn class="blue--text" v-if="(item.packs.length < onlineRigs.length) && isToday" icon small @click="addJobs(item)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-card-title>

              <v-divider></v-divider>

      <v-data-table 
                
                 hide-default-footer
                    :headers="headers"
                    :items="item.packs"
                    :items-per-page="10"
                    flat
                    >
         <template v-slot:item.actions="{ item }">
          
          <v-btn v-if="isToday" class="red--text" icon small @click="undo(item)">
            <v-icon center>mdi-undo-variant</v-icon></v-btn>
          </template> 
          <template slot="body.append">
                      <tr class="blue--text">
                        <th class="title">&nbsp;</th>
                        <th class="title">{{ sum(item.packs, 'jobs') }}</th>
                        <th class="title">{{ sum(item.packs, 'cutaways') }}</th>
                        <th class="title">&nbsp;</th>
                        
                    </tr>
                  </template>

      </v-data-table> 

            </v-card>
          </v-col>
        </v-row>
      </template>

    </v-data-iterator>
              
        
          </v-col>
     
    
          <v-col cols="12" md="4">



        <v-list v-if="packsReport && packsReport.length > 0">
          <v-list-item>
              <v-list-item-content>Total Pack Jobs</v-list-item-content>
                <v-list-item-content class="align-end">

                      {{ packsReport ? packsReport[0].jobs : 0 }}
                    </v-list-item-content>
                  </v-list-item>
            <v-list-item>
              <v-list-item-content>Completed Jumps</v-list-item-content>
                <v-list-item-content class="align-end">
                      {{ totalJumps ? totalJumps.Complete : 0 }}
                    </v-list-item-content>
                  </v-list-item>
            
            
              <v-list-item>
              <v-list-item-content>Discrepancy</v-list-item-content>
                <v-list-item-content class="align-end">
                      {{ packsReport ? packsReport[0].discrepancy : 0 }}
                    </v-list-item-content>
                  </v-list-item>

                <v-list-item>
                <v-list-item-content>
                  Reason 

                </v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ packsReport ? packsReport[0].reason : " " }}
                      <v-btn icon small @click="editReason(packsReport[0])">
                  <v-icon>mdi-pencil</v-icon> 
                </v-btn>
                      
                    </v-list-item-content>
                  </v-list-item>

        </v-list>

          </v-col>

    </v-row>

    <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
      <v-form ref="form" v-model="valid" @submit.prevent="saveReport">
                    <v-card color="lighten-1">
                  
                        <v-toolbar>
                                <v-toolbar-title>
                                    <span class="headline">{{formTitle}}</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        <v-card-text>

                          <v-select v-if="rigIDsByPacker.length == 0"
                                    v-model="editedItem.packer_id"
                                        :items="activePackers"
                                        item-text="name"
                                        item-value="id"
                                        placeholder="Packer"
                                        hide-no-data
                                        :rules="packerRules"
                                    >

                                     </v-select>

                                  

                          <fieldset v-for="(p, index) in editedItem.packedRigs" class="inline-form input-3">

                            <v-checkbox 
                              v-model="p.sel"
                              :label="p.rig"
                            ></v-checkbox>
                            <v-text-field  :disabled="!p.sel"
                            :rules="!p.sel ? [] : reqNumber"
                             label="Pack Jobs" v-model.number="p.jobs" type="number"
                            
                                              ></v-text-field>
                            <v-text-field  :disabled="!p.sel"
                            label="Cutaways" v-model.number="p.cutaways" type="number"
                                              ></v-text-field>
                           
                          </fieldset>


                          <fieldset class="inline-form input-3">

                            <v-text-field readonly label="Completed Jumps" v-model.number="totalJumps.Complete" type="number"
                                              ></v-text-field>
                            <v-text-field
                            v-model.number="totalJobs"
                             readonly label="Total Jobs"  type="number"
                                              ></v-text-field>
                            <v-text-field 
                            label="Discrepancy" readonly
                            v-model.number="discrepancy" type="number"
                                              ></v-text-field>

                          </fieldset>
                                        
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :loading="saving" color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn :loading="saving" color="blue darken-1" type="submit" :disabled="!valid">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                    </v-form>
                </v-dialog>
	</section>
    
</template>


<script>
    import { mapState } from 'vuex'
    import { mapGetters } from 'vuex'


    export default {
      
        data() {

            return {

              headers : [
                  { text : "Rig", align: 'left', value: "rig.name", sortable : false },
                  { text : "Jobs", align: 'left', value: "jobs", sortable : false },
                  { text : "Cutaways", align: 'left', value: "cutaways", sortable : false },
                   { text : "", align: 'left', value: "actions", sortable : false },
              ],


              totalsHeaders : [
                { text : "Total Jobs", align: 'left', value: 'jobs', sortable : true },
                { text : "Completed Jumps", align: 'left', value: 'jumps', sortable : true },
                { text : "Discrepancy", align: 'left', value: 'discrepancy', sortable : true }
              ],

              req : [ v => !!(v && v.length) || 'Item is required'],

              reqNumber : [v => Number.isInteger(Number(v)) && v > 0 || "The value must be an integer number"],

              packerRules:[
                        v => !!v || 'Please select a Packer',
                      ],

              dialog : false,
              valid : false,
              editedIndex: -1,

              saving : false,
              discrepancy : 0,

              //selectedPacker : null,

              editedItem : {

                packedRigs : [],
                packer_id : null,
                jobs : 0,
                discrepancy : 0,
                
              },

              defaultPack : {
                jobs : 0,
                cutaways : 0,
                rig : "",
                rig_id : null,
                packer_id : null,
                packDate : this.currentDate
              },

              rigIDsByPacker : []

            }
        },

        mounted () {

          this.$store.dispatch('fetchPacksReportbyDate', 'today')

          this.$store.dispatch('fetchRigs')

          if (this.packers.length == 0)
          this.$store.dispatch('fetchPackers')

          
        },


        computed: {

          ...mapState(['dailypacks','dailysales','user','packers']),
          ...mapGetters(['activePackers']),

          

          onlineRigs() {

            return this.$store.getters.onlineRigs

           },

           filteredRigs() {

              return this.onlineRigs.filter((r) => { return !this.rigIDsByPacker.includes(r.id) }) || []

           },

           packsReport() {

            return this.$store.getters.dailyPacksReport || null

           },




           packJobs() {

            return this.$store.getters.packs || null
           },


           packedRigs () {

            return this.editedItem.packedRigs ? this.editedItem.packedRigs.filter((el) => { 

                return el.sel

              }) : []

           },


           totalJumps () {

              return this.dailysales.totalJumps || 0
            },


           totalJobs () {

            // console.log(this.editedItem.packedRigs)

            const totalJobs = this.editedItem.packedRigs ? this.sum(this.editedItem.packedRigs,'jobs') + this.editedItem.jobs : 0

// console.log(this.editedItem.jobs)

            this.discrepancy = this.totalJumps ? (totalJobs - this.totalJumps.Complete) : 0

            return totalJobs || 0
           },


            

            formTitle () {

                return this.rigIDsByPacker.length == 0 ? 'Add Packing Jobs' : 'Add Packing Jobs to ' + this.editedItem.name
            },

            currentDate () {
              return this.$store.state.currentDate
            }, 

            isToday () {
              return this.$store.state.isToday
            }

        },


        watch : { 

          // editedItem(val) {

          //   console.log("editedItem watch: ", val)

          // },


          dialog (val) {
                val || this.close()
            },
      },
        

        methods: {

          undo(item) {

                confirm('Confirm you want to undo this packing Job? This action can not be undone') && 

                axios.delete('/api/packs/' + item.id)
                        .then( response => {

                            this.updateJumpsCount('undo',[item])                             
                        })
                        .catch( err => {
                            console.log( err )
                        })
              

          },

          
          makeFields() {

          
            const fields = [],
            selectedPacker = this.editedItem.packer_id,
            defaultPackField = this.defaultPack,
            currentDate = this.currentDate


            this.filteredRigs.forEach(function (r){

              const field = Object.assign({}, defaultPackField)

              field.rig_id = r.id
              field.packer_id = selectedPacker
              field.rig = r.rig
              field.packDate = currentDate
              fields.unshift(field)
            })

            fields[0].sel = true //just to preselect at least one

            return fields
          },

          logInfo(item) { 

           this.editedItem.packedRigs = this.makeFields()

           if(this.activePackers.length == 1) {

                  this.editedItem.packer_id = this.activePackers[0].id                  

                }

            this.dialog = true
          },


          editReport(item) { 

                this.editedIndex = this.packsReport.indexOf(item)
                item.packedRigs = this.makeFields()

                this.editedItem = Object.assign({}, item)

                if(this.activePackers.length == 1) {

                  this.editedItem.packer_id = this.activePackers[0].id                  

                }

                this.dialog = true
            },



            getRigIDsByPacker(packerJobs) {

              return packerJobs.map(function(r){ return r.rig_id }) || []

            },


            addJobs(item) {

              this.rigIDsByPacker = this.getRigIDsByPacker(item.packs)
              
              let editedReport = {
                ...this.packsReport[0],
                ...item
              }


              editedReport.packer_id = item.id
              editedReport.packedRigs = this.makeFields()

                this.editedIndex = 0
                this.editedItem = Object.assign({}, editedReport)

//                 this.editedItem.packer_id = item.id
                 this.editedItem.id = this.packsReport[0].id
                 //this.editedItem.packedRigs = this.makeFields()
                 this.dialog = true
            },




            editReason(item) {

              const reason = prompt('Enter the Reason for Discrepancy')

              if ( reason ) {

                this.editedIndex = this.packsReport.indexOf(item)
                this.editedItem = Object.assign({}, item)

                this.editedItem.reason = reason

                  axios.put('/api/packing_jobs/' + this.editedItem.id, this.editedItem)

                        .then( response => {
                            
                            this.$store.dispatch('fetchPacksReportbyDate', this.currentDate)

                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })


              }
            },


          close () {

            this.dialog = false

            this.$nextTick(() => {
              this.editedItem = Object.assign({}, this.defaultItem)
              this.editedIndex = -1

              this.rigIDsByPacker = []

            this.saving = false
                  
              })
          },


              saveReport () {

                this.saving = true

                

                this.editedItem.packDate = this.currentDate
                this.editedItem.jobs = this.totalJobs
                this.editedItem.packedRigs = this.packedRigs
                this.editedItem.discrepancy = this.discrepancy
                 

                


                if (this.editedIndex > -1) {

                    axios.put('/api/packing_jobs/' + this.editedItem.id, this.editedItem)

                        .then( response => {

                          this.updateJumpsCount('add', this.editedItem.packedRigs)
                            
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/packing_jobs', this.editedItem)
                    .then( response => {

                       // this.$store.dispatch('fetchPacksReportbyDate', this.currentDate)

                       this.updateJumpsCount('add', this.editedItem.packedRigs)

                        // this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

              updateJumpsCount(action, items) {

                axios.put('/api/components/updateJumpsCount/'+ action, items)
                              .then( response => {

                                  this.$store.dispatch('fetchPacksReportbyDate', this.currentDate)
                                  this.close()
                                  
                              })
                              .catch( err => {
                                  console.log( err )
                              })

              }

      
        
        }
    }
</script>
